import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { getUserTraits, getCommonTealiumProps } from 'helpers/AccountHelper';
import sharedTheme from '../OverlayTheme.css';
import Style from './EmailCapture.module.scss';

const EmailCapture = (props = {}) => {
  const {
    background,
    emailCaptureInput,
    onChange,
    onSubmit,
    isValid,
    title,
    subtitle,
    entitlements,
  } = props;
  const {
    email_capture_message: message,
    email_capture_submit_text: submitText,
    email_capture_input_placeholder: inputPlaceholderText,
  } = window.Language;
  const analyticsProps = {
    page_item_title: title,
    page_item_subtitle: subtitle,
    entitlements,
    ...getUserTraits(),
  };
  const [isSubmitted, setIsSubmitted] = useState(false);
  const submittedRef = useRef(false);
  submittedRef.current = isSubmitted;
  useEffect(() => {
    handleAnalytics({
      event: Events.EMAIL_ROADBLOCK_IMPRESSION,
      payload: analyticsProps,
      tealiumPayload: {
        ...getCommonTealiumProps(),
      },
    });
    return () => {
      if (!submittedRef.current && window?.location?.pathname?.includes('account/')) {
        handleAnalytics({
          event: Events.EMAIL_ROADBLOCK_BYPASS,
          payload: analyticsProps,
          tealiumPayload: {
            ...getCommonTealiumProps(),
          },
        });
      } else if (!submittedRef.current) {
        handleAnalytics({
          event: Events.EMAIL_ROADBLOCK_ABANDON,
          payload: analyticsProps,
          tealiumPayload: {
            ...getCommonTealiumProps(),
          },
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSubmit = props => {
    setIsSubmitted(true);
    handleAnalytics({
      event: Events.EMAIL_ROADBLOCK_SUBMIT,
      payload: analyticsProps,
    });
    onSubmit(props);
  };

  return (
    <div className={classNames(Style.container, sharedTheme.container)}>
      <img className={Style.background} src={background} alt="" />
      <div className={Style.backgroundOverlay}>
        <div className={classNames(Style.messageContainer, sharedTheme.messageContainer)}>
          <p className={Style.message}>{message}</p>
          <div className={Style.emailCaptureContainer}>
            <input
              type="email"
              className={Style.input}
              onChange={onChange}
              placeholder={inputPlaceholderText}
              value={emailCaptureInput}
            />
            <button className={Style.button} onClick={handleSubmit} disabled={!isValid}>
              {submitText}
              <Icon
                color="white"
                size="small"
                viewBox="0 0 18 32"
                icon="ios-arrow-right"
                ariaHidden
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

EmailCapture.propTypes = {
  background: PropTypes.string.isRequired,
  emailCaptureInput: PropTypes.string.isRequired,
  entitlements: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default EmailCapture;
